/**
 * EventON Promote: blocks - Popup
 *
 * Registering a shortcode block with Gutenberg.
 */
/*jshint esversion: 6 */
//  Import CSS.
import './style.scss';
import './editor.scss';

const { __ } = wp.i18n; // Import __() from wp.i18n
const { registerBlockType } = wp.blocks; // Import registerBlockType() from wp.blocks

// Register editor components
const {
    InspectorControls,
} = wp.editor;
var el = wp.element.createElement;
// Register components
const {
    PanelBody,
    SelectControl,
    ToggleControl,
    TextControl,
} = wp.components;

registerBlockType( 'mmt-promote/promote-embed', {
    // Block name. Block names must be string that contains a namespace prefix. Example: my-plugin/my-custom-block.
    title: __( 'Promote Embeds', 'mmt-promote' ), // Block title.
    icon: {
        foreground: '#FF6978 ',
        src: 'shield'
        }, 
    category: 'mmt-promote-block', // Block category — Group blocks together based on common traits E.g. common, formatting, layout widgets, embed.
    keywords: [
        __( 'Promote' ),
        __( 'Event' ),
        __( 'promote-embed' ),
    ],
    attributes: {
        embedEventID: {
            type: 'string',
            default: '',
        },
        embedType: {
            type: 'string',
            default: '1',
        },
        embedOptin: {
            type: 'bool',
            default: false
        },
    },
    supportHTML: true,

    //edit: PromotePopup,
    edit: function( props  ){
        var embedEventID = props.attributes.embedEventID;
        var embedType = props.attributes.embedType;
        var embedOptin = props.attributes.embedOptin;
        var setAttributes = props.setAttributes;
        var isPremium = mmt_promote_block_plans_fm.is_plan_premium;
        let premiumDataTgl;
        if (isPremium) {
            premiumDataTgl =
                <ToggleControl
                    label={__('Enable Optin Form','mmt-promote')}
                    checked={embedOptin}
                    onChange= { (option) => setAttributes({embedOptin: option }) }
                />;
        }
        return [
            <div className={props.className} key={props.className}>
            <h4 id="mmt-propmote-embed-section-title">{__('EventON Promote Embed', 'mmt-promote') } </h4>
            <p>{__('Please check right hand side Block Panel for settings.','mmt-promote')}</p>
                <InspectorControls>
                    <PanelBody title={ __( 'Embed Settings', 'mmt-promote' ) } >
                        <TextControl 
                                label = {__('Event ID', 'mmt-promote')}
                                placeholder={ __( 'e.g 333', 'mmt-promote' ) }
                                value= {embedEventID}
                                className='epa-popup-event-id'
                                onChange={( value ) => setAttributes( { embedEventID: value } )}
                        />
                        <SelectControl
                            label={ __('Embed Type', 'mmt-promote') }
                            value= { embedType ? embedType : 1}
                            onChange={(value) => setAttributes({embedType : value}) }
                            options={ [
                                { label: __('On Top of Page', 'mmt-promote'), value: '1' },
                                { label: __('On Bottom of Page','mmt-promote'), value: '2' },
                                //{ label: 'In Widget', value: '25%' },
                            ]}
                        />
                        {premiumDataTgl}
                        </PanelBody>
                </InspectorControls>
            </div>
        ];
    },

    save: function(props) {
        //TextControl.Content
        return null;
        
        },
} );
